export class AccordionItem extends HTMLElement {
  static get observedAttributes() {
    return ['open'];
  }

  constructor() {
    super();
  }

  connectedCallback() {
    let header = this.querySelector('header');
    if (this.getAttribute('open') != null) {
      this.setAttribute('open', 1);
    }
    header?.addEventListener('click', () => this.setAttribute('open', Number(this.getAttribute('open')) ? 0 : 1));
    header?.addEventListener('keydown', (ev) => {
      if (ev.keyCode == 13) {
        ev.preventDefault();
        this.setAttribute('open', Number(this.getAttribute('open')) ? 0 : 1);
      }
    });
    this.updateTabIndex();
  }

  attributeChangedCallback(name, oldVal, newVal) {
    // console.log(`Attribute: ${name} changed from ${oldVal} to ${newVal}`);
    let icon = this.querySelector('.icon use');
    icon.setAttribute('href', `#${newVal == 1 ? 'minus' : 'plus'}`);
    this.updateTabIndex();
  }

  updateTabIndex() {
    const focusableElements = this.querySelector('.content').querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );

    if (this.getAttribute('open') == 1) {
      focusableElements.forEach((element) => {
        element.setAttribute('tabindex', '0');
      });
    } else {
      focusableElements.forEach((element) => {
        element.setAttribute('tabindex', '-1');
      });
    }
  }
}
